<template>
  <!-- begin:: Footer -->
  <div
    class="footer pb-4 d-flex flex-lg-column"
    id="kt_footer">
    <div
      class="d-flex align-items-center justify-content-between flex-wrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }">
      <div class="text-dark font-size-xs font-weight-bold">
        <span class="text-muted font-weight-bold mr-1">
          &copy; 2018 - 2024
        </span>
        <span
          class="text-dark-75 text-hover-primary mr-2">
          Hexallion VPN Admin Panel
        </span>
        <b-badge
          id="app-version"
          variant="light"
          v-b-tooltip.hover
          title="Client version"
          class="font-size-xs cursor-help">v{{ currentVersion }}</b-badge>
        <b-badge
          id="backend-version"
          variant="light"
          v-b-tooltip.hover
          title="API version"
          class="font-size-xs cursor-help ml-2">v{{ backendVersion }}</b-badge>
      </div>
      <div class="nav nav-dark font-weight-bold font-size-xs">
        <a
          href="https://hostry.com/about/"
          target="_blank"
          class="nav-link pr-3 pl-0">
          About Us
        </a>
        <a
          href="https://help.hostry.com/"
          target="_blank"
          class="nav-link px-3">
          Help Center
        </a>
        <a
          href="https://hostry.com/contact/"
          target="_blank"
          class="nav-link pl-3 pr-0">
          Contacts
        </a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'KTFooter',
  computed: {
    ...mapGetters(['layoutConfig', 'currentVersion', 'backendVersion']),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig('footer.width') === 'fluid'
    },
  },
}
</script>
